<template>
  <v-card>
    <v-img v-if="empresa.url_imagem_posto" width="700" :src="empresa.url_imagem_posto" class="mb-3"></v-img>
    <v-card v-else color="grey" height="300" class="rounded-0 mb-3">
        <v-layout justify-center align-center fill-height>
          <div class="title white--text pa-4 text-xs-center">Sem Imagem</div>
        </v-layout>
    </v-card>
    <v-card-title class="pb-0">
      <h3 v-if="empresa" style="width: 100%; text-align: center;">{{ empresa.nome_fantasia }}</h3>
    </v-card-title>
    <v-card-text class="mb-4">
        <v-layout justify-space-around wrap class="mb-4">
          <v-flex xs5 class="mb-2">CNPJ: <b>{{empresa.cnpj}}</b></v-flex>
          <template v-if="empresa.endereco">
            <v-flex xs5 class="mb-2">Logradouro: <b>{{empresa.endereco.logradouro}}</b></v-flex>
            <v-flex xs5 class="mb-2">Número: <b>{{empresa.endereco.numero}}</b></v-flex>
            <v-flex xs5 class="mb-2">Complemento: <b>{{empresa.endereco.complemento}}</b></v-flex>
            <v-flex xs5 class="mb-2">Bairro: <b>{{empresa.endereco.bairro}}</b></v-flex>
            <v-flex xs5 class="mb-2">Cidade: <b>{{empresa.endereco.cidade}}</b></v-flex>
            <v-flex xs5 class="mb-2">Estado: <b>{{empresa.endereco.estado}}</b></v-flex>
            <v-flex xs5 class="mb-2">CEP: <b>{{empresa.endereco.cep}}</b></v-flex>
          </template>
          <v-flex xs12 class="mb-2" v-if="combustiveis.length > 0">
            <v-divider></v-divider>
            <h3 style="text-align: center; font-weight: 500;" class="mt-3">Combustíveis do empresa {{ empresa.nome_fantasia }}</h3>
          </v-flex>
        </v-layout>
        <v-layout justify-center>
          <v-card dark color="primary lighten-2" style="width: 90%">
            <l-map
              ref="myMap"
              v-if="mapa.center"
              style="height: 40vh; width: 100%; z-index: 0;"
              :options="{ zoomControl: zoomControl }"
              :zoom="mapa.zoom"
              :center="mapa.center"
              @update:zoom="zoomUpdated"
              @update:center="centerUpdated"
              @update:bounds="boundsUpdated"
            >
              <l-tile-layer
                :name="mapa.name"
                :url="mapa.url"
                :attribution="mapa.attribution"></l-tile-layer>
                <l-layer-group>
                  <app-marker @postoSelecionado="empresa"  :key="`${empresa.cnpj}-marcador`" :empresaSelecionada="empresa"></app-marker>
                </l-layer-group>
            </l-map>
          </v-card>
        </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-btn block @click="$emit('fechar')">Fechar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import { LMap, LTileLayer, LLayerGroup } from 'vue2-leaflet'
import AppMarker from '@/components/util/Marker'

export default {
  props: ['empresa'],
  components: {
    LMap,
    LTileLayer,
    LLayerGroup,
    AppMarker
  },
  data: () => ({
    combustiveis: [],
    mapa: {
      name: 'Mapa',
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
      maxZoom: 18,
      zoom: 14,
      center: null,
      bounds: null,
      zoomControl: false
    }
  }),
  computed: {
    zoomControl () {
      return !this.$vuetify.breakpoint.xs
    }
  },
  beforeMount () {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.carregarMapa(position.coords.latitude, position.coords.longitude)
      })
      /* geolocation is available */
    } else {
      this.$root.router.push(-1)
      /* geolocation IS NOT available */
    }
  },
  methods: {
    zoomUpdated (zoom) {
      this.mapa.zoom = zoom
    },
    centerUpdated (center) {
      this.mapa.center = center
    },
    boundsUpdated (bounds) {
      this.mapa.bounds = bounds
    },
    carregarMapa (latitude, longitude) {
      this.mapa.center = [this.empresa.latitude, this.empresa.longitude]
    },
    corrigirPreco (valor) {
      if (!valor) return
      var temCasaDecimal = valor.toString().replaceAll('.', ',').split(',')[1] != null
      if (temCasaDecimal && valor.toString().replaceAll('.', ',').split(',')[1].length > 2) {
        var casasDecimais = valor.toString().replaceAll('.', ',').split(',')[1]
        var filtrando = casasDecimais.substring(0, 2)
        return parseFloat([valor.toString().split('.')[0], filtrando].join('.')).toFixed(2)
      }
      return valor.toFixed(2)
    }
  }
}
</script>
